<template lang="pug">
	.product-gallery
		template(v-if="product.images")
			.product-gallery__sale(v-if="product.on_sale && $cookies.get('country') !== 'Country'") Sale

			//- affix.product-gallery__thumbs(relative-element-selector="#productRow" :offset="{ top: 100, bottom: 0 }")
			.product-gallery__thumbs
				scrollactive.thumbs-row
					a.thumb.scrollactive-item(v-for="(image, index) in product.images"
																		:key="index" 
																		:href="`#galley-photo-${image.name}`")
						img.lazyload(src="/img/img-preloader.svg"
												 :data-src="image.src" 
												 :alt="product.name + $t('pages.catalog.productImageNumber') + (index + 1)"
												 :title="$t('pages.catalog.productImageTitle') + product.name + $t('pages.catalog.productImageNumber') + (index + 1)")

			.product-gallery__images(v-viewer="options")
				.image(v-for="(image, index) in product.images" 
							 :key="index"
							 :id="`galley-photo-${image.name}`")
					img.lazyload(src="/img/img-preloader.svg"
												:data-src="image.src" 
												:alt="product.name + $t('pages.catalog.productImageNumber') + (product.images.length + index + 1)"
												:title="$t('pages.catalog.productImageTitle') + product.name + $t('pages.catalog.productImageNumber') + (product.images.length + index + 1)")
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      options: {
        viewed(e) {
          const canvas = this.viewer.canvas
          const image = e.detail.image

          canvas.addEventListener('mousemove', e => {
            image.style.transform = `translateY(-${e.offsetY}px)`
          })
        }
      }
    }
	},
}
</script>

<style lang="scss">
@import '~assets/scss/helpers/vars';
@import '~assets/scss/helpers/mixins';
@import '~assets/scss/components/v-viewer';

.product-gallery {
  position: relative;

  &__sale {
    position: absolute;
    top: 8%;
    right: 0;
    @include size(56px);
    color: $whiteColor;
    font-size: 16px;
    font-style: italic;
    line-height: 56px;
    text-align: center;
    border-radius: 50%;
    background-color: $redColor;
    user-select: none;
  }

  &__thumbs {
    width: 625px;
  }

  &__images {
    padding-top: 90px;
    cursor: url('/img/zoom-photo-cursor@1x.png'), auto;
    cursor: -webkit-image-set(
        url('/img/zoom-photo-cursor@1x.png') 1x,
        url('/img/zoom-photo-cursor@2x.png') 2x
      ),
      auto;

    img {
      margin: 0 auto;
    }
  }
}

.thumbs-row {
  display: flex;
  flex-wrap: wrap;

  .thumb {
    flex: 0 0 60px;
    max-width: 60px;
    margin-right: 10px;

    &.is-active {
      opacity: 0.5;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
